module.exports = __webpack_public_path__ + "static/gov-5a2ce5e18545ffe8c2aad063311c116c.svg";